import {
  FormControl,
  Input,
  Text,
} from '@chakra-ui/react';
import React, {
  ComponentPropsWithoutRef,
} from 'react';
import {
  Field,
} from 'react-final-form';
import Label from '../../../components/Intake/Label';

const InputField = (
  {
    name, label, validate, optional, placeholder, maxLength, flex, ...rest
  }: {
    name: string,
    label?: string,
    optional?: boolean,
    validate?: (value: any) => string | undefined,
    placeholder?: string,
    maxLength?: number,
    [x: string]: any;
  },
) => {
  return (
    <Field name={name} validate={validate}>
      {({ input, meta }) => (
        <FormControl flex={flex}>
          <Label optional={optional}>{label}</Label>
          <Input
            {...input}
            {...rest}
            placeholder={placeholder}
            maxLength={maxLength}
            isInvalid={meta.touched && meta.error}
            errorBorderColor="red.300"
          />
          {meta.touched && meta.error && (
            <Text color="red.300" fontSize="sm" mt={2} px={4}>{meta.error}</Text>
          )}
        </FormControl>
      )}
    </Field>
  );
};

export default InputField;
